import React from "react";
import { Tooltip } from "react-tooltip";
import { TooltipComponentStyled } from "./TooltipComponentStyled";
import { TooltipComponentProps } from "../../entities/TooltipComponent";

import "react-tooltip/dist/react-tooltip.css";

const TooltipComponent: React.FC<TooltipComponentProps> = ({
  anchor,
  children,
  place = "top",
  isOpen,
}) => (
  <TooltipComponentStyled>
    <Tooltip isOpen={isOpen} anchorSelect={anchor} place={place}>
      {children}
    </Tooltip>
  </TooltipComponentStyled>
);

export default TooltipComponent;
